import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from 'src/app/core/http/http.service';
import { API } from 'src/app/configs';
import { GeneralService } from 'src/app/shared/services/general.service';

@Component({
    selector: 'accessManager',
    templateUrl: './accessManager.component.html',
    styleUrls: ['./accessManager.component.scss']    
})
export class AccessManagerComponent implements OnInit{

    formGroup: FormGroup;
    params:any={};
    list:any = [];
    perfil = [];

    constructor(
        private formBuilder: FormBuilder,
        protected httpService: HttpService,
        protected gs: GeneralService,
        private cdr: ChangeDetectorRef
    ){
        this.perfil = this.gs.getGeneralData('perfil');
    }

    ngOnInit(){

        this.formGroup = this.formBuilder.group({
            perfil_id: ['2', [Validators.required]],
            email: ['', [Validators.required, Validators.email]],
        });
        this.getList();
     //   console.log(this.params);
    }

    getList(){
        this.httpService.post<any>(API.person.admin.list, 
            ['1','2','3','7'].indexOf(this.params?.perfil_id) > -1?
            {
                "owner_person_id": this.params?.person_id,
                "type":"usercompanies",
                "sort_column":"company_name",
                "sort_direction":"ASC",
                "total_rows":100,
                "current_page":1,
                "search":[]
            } :
            {
            "type": "companyusers",
            "sort_column": "status",
            "sort_direction": "ASC",
            "total_rows": 100,
            "current_page": 1,
            "owner_person_id":this.params?.person_id
          })
          .then(result => {
              this.list = result;
              this.cdr.detectChanges();
          })
          .catch(err => this.gs.error(err));
    }
    
    save(){
        this.httpService.put<any>(API.person.admin.companyuser,{
            "owner_person_id":this.params?.person_id,
            perfil_id: this.formGroup.controls['perfil_id'].value,
            email: this.formGroup.controls['email'].value
        }).then(result => {
            this.formGroup.reset();
            this.gs.message('Usuário adicionado com sucesso');
            this.getList();
        })
        .catch(err => this.gs.error(err));
    }

    delete(event, person_id){
        this.httpService.del<any>(API.person.admin.companyuser,
            ['1','2','3','7'].indexOf(this.params?.perfil_id) > -1?
            {
                owner_person_id : person_id,
                person_id : this.params?.person_id
            } 
            :
            {
                owner_person_id : this.params?.person_id,
                person_id : person_id
            }
        ).then(
            result => {
                this.getList();
                this.gs.message('Usuário removido com sucesso');
        })
        .catch(err => this.gs.error(err));
    }

    copyLink(event, item){
        const el = document.createElement('textarea');
        el.value = 'https://www.centralcorretor.com.br/emailsignup/'+item?.hash;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.gs.message('Link copiado');
    }
}
